import styled from 'styled-components';

export const paneWidth = 400;

export const PreviewImageStyled = styled.div`
  position: relative;
  border: 4px solid #333333;
  transition: 0.4s;

  > img {
    display: block;
    width: 100%;
    cursor: pointer;
    padding: 0;
  }

  > span {
    margin: 0px;
    max-width: 75%;
    font-size: 16px;
    position: absolute;
    top: 5px;
    left: 5px;
    pointer-events: none;
    transform-origin: top left;
    background-color: #000000aa;
    border-radius: 5px;
    padding: 5px;
    overflow: hidden;
  }
`;

export const CategoryPaneStyled = styled.div`

  width: 100%;
  height: 100%;
  display: flex;
  flex-flow: column;

  
  > .SubHeading {
    padding: 10px;
    font-size: smaller;
  }
  > .grid {
    position: relative;
    flex: 1;
    width: 100%;
    display: block;
    overflow-x: hidden;
    overflow-y: auto;

    > div {
      width: 100%;
      max-height: 100%;
      display: grid;
      grid-template-columns: repeat(2, 1fr);
      grid-auto-rows: minmax(${paneWidth / 2 - 100}px, auto);
      align-items: center;
        
      background-color: #333333;
    }
  }
`;

export const ImageChooserStyled = styled.div`
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  pointer-events: all;

  display: -webkit-flexbox;
  display: -ms-flexbox;
  display: -webkit-flex;
  display: flex;
  flex-flow: row;
  
  background-color: #101010;

  #TitleShower {
    position: absolute;
    pointer-events: none;
    background-color: #000000aa;
    border-bottom-right-radius: 8px;
    top: 0px;
    left: 0px;
    width: 400px;
    height: 130px;
  }

  > .AnimatedHamburgerButton {
    position: absolute;
    border-radius: 8px;
    top: 3px;
    left: 3px;
    border-radius: 8px;
  }

  > .AnimatedHamburgerButton:hover {
    background-color: black;
    background-color: #80808080;
  }

  #PreviewPane {
    width: ${paneWidth}px;
    height: 100%;
    background-color: #333333;
    overflow: hidden;
    position: relative;

    .FAButton {
    }
  }

  #Description {
    flex: 1;

    display: flex;
    align-items: center;
    justify-content: center;
    position: relative;
    text-align: center;

    > img {
      position: absolute;
      width: 100%;
      height: 100%;
      cursor: pointer;
      object-fit: contain;
    }
    #Background {
      left: -50px;
      top: -50px;
      width: calc(100% + 100px);
      height: calc(100% + 100px);
      object-fit: cover;
      filter: blur(15px) grayscale(50%);
    }
    > span {
      position: absolute;
      top: 50%;
      left: 50%;
      transform: translate(-50%, -50%);
      text-shadow:
        -1px -1px 0 #000,
        1px -1px 0 #000,
        -1px 1px 0 #000,
        1px 1px 0 #000;
      margin: 0;
      pointer-events: none;
      background-color: #000000aa;
      border-radius: 5px;
      padding: 5px;

      font-size: 20px;
      > h1 {
        font-size: 30px;
      }
      > h2 {
        font-size: 25px;
      }
    }
  }

`;